import { useEffect, useState } from 'react';

import { cn } from '@yakit/ui-components';

import { Skeleton } from '@yakit/ui-components';

export const VDLDefaultIframe = ({
  src
}: {
  src: string | undefined | null;
}) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (src) {
      setLoaded(false);
    }
  }, [src]);

  return (
    <>
      {!loaded && <Skeleton className="h-full w-full" />}
      {src && (
        <iframe
          className={cn('h-full w-full', { hidden: !loaded })}
          src={import.meta.env.DEV ? `https://yakit.pro/${src}` : src}
          onLoad={() => setLoaded(true)}
        />
      )}
    </>
  );
};
